import PageTitle from "../../common/pagetitle/pagetitle";
import React, {useEffect, useState} from "react";
import axios from "axios";
import { serverLink} from "../../url";
import {showAlert, showConfirm} from "../../common/sweetalert/sweetalert";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import DataTable from "../../common/data-table/data-table";
import Loader from "../../common/loader";
import GalleryCategoryForm from "./gallery-category-form";

function GalleryCategory(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [IsFormLoading, setIsFormLoading] = useState(false)
    const [categoryList, setCategoryList] = useState([])
    const header = ["S/N", "Category Name",  "Delete"];
    const [formData, setFormData] = useState({
        EntryID: "",
        CategoryName: "",
        INSERTED_BY: `${props.loginData[0]?.userID}`,
    })


    useEffect( () => {
        getData();
    }, [""]);


    const getData = async () => {
        await axios.get(`${serverLink}gallery/category/list`)
            .then((result) => {
                if (result.data.length > 0) {
                    setCategoryList(result.data);
                }else {
                    setCategoryList([])
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }


    const delete_timetable = async (id) => {
        toast.info("please wait...");
        await axios.delete(`${serverLink}gallery/delete/category/${id}`).then((res) => {
            if (res.data.message === "success") {
                toast.success("Deleted Successfully");
                getData();
            } else {
                toast.error("NETWORK ERROR. Please try again!");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("NETWORK ERROR. Please try again!");
        });
    }

    const  showTable = () => {
        try {
            return categoryList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index +1}</td>
                        <td>{item.categoryName}</td>
                        <td>
                            <a href="#" className={"btn btn-danger btn-sm "} onClick={() => delete_timetable(item.categoryID)}>
                                Delete
                            </a></td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };



    const onEdit = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        });
    }

    const onSubmit = async () => {
        if (formData.CategoryName.trim() === "") {
            showAlert("EMPTY FIELD", "Please enter category name", "error");
            return false;
        }

        if (formData.EntryID === "") {
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            await axios
                .post(`${serverLink}gallery/category/add`, sendData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Category Added Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("close").click();
                        setFormData({
                            ...formData,
                            EntryID: "",
                            CategoryName: "",
                        });

                    }else if(result.data.message === "exist"){
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Category already exist!",
                            "error"
                        );
                    }
                    else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }else{
            let sendData = {
                ...formData,
            }
            setIsFormLoading(true);
            await axios
                .patch(`${serverLink}gallery/category/update`, sendData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success("Category Updated Successfully");
                        setIsFormLoading(false);
                        getData();
                        document.getElementById("close").click();
                        setFormData({
                            ...formData,
                            EntryID: "",
                            CategoryName: "",
                        });
                    } else {
                        setIsFormLoading(false);
                        showAlert(
                            "ERROR",
                            "Something went wrong. Please try again!",
                            "error"
                        );
                    }
                })
                .catch((error) => {
                    setIsFormLoading(false);
                    showAlert(
                        "NETWORK ERROR",
                        "Please check your connection and try again!",
                        "error"
                    );
                });
        }


    }

    return(IsLoading ? <Loader/> :
            <>
                <PageTitle title={["Home", "Gallery Category"]} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Manage Gallery Category</h4>
                                    <div className="d-flex no-block align-items-center m-b-30 mt-3">
                                        <div className="ml-auto">
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-info" data-toggle="modal" data-target="#responsive-modal" onClick={() => {
                                                    setFormData({
                                                        ...formData,
                                                        EntryID: "",
                                                        CategoryName: "",
                                                    });
                                                }}>
                                                    <i className="fa fa-plus"></i> Add Gallery Category
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <DataTable tableID="GalleryCategory" header={header} body={showTable()} title="Website Gallery Category Report"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GalleryCategoryForm
                    title="Manage Gallery"
                    formData={formData}
                    onEdit={onEdit}
                    onSubmit={onSubmit}
                    IsFormLoading={IsFormLoading}
                />
            </>
    )
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(GalleryCategory);

